<template>
  <div class="container-fluid">
    <b-card no-body class="card-transparent-background mt-4 mb-2">
      <b-card-header class="py-0 pl-0"
        ><b-card-body class="py-2">
          <b-card-title class="card-title-doorder my-3"
            >Order Details
          </b-card-title>
        </b-card-body>
      </b-card-header>
    </b-card>

    <b-card no-body class="card-transparent-background mt-0">
      <b-card-body class="p-0">
        <b-tabs
          content-class="mt-3"
          v-model="tabIndex"
          class="form-steps-container-doorder"
          nav-class="row justify-content-center"
        >
          <b-tab title-item-class="col-lg-2 col-3 text-lg-left text-center">
            <template slot="title">
              <b-row>
                <b-col lg="2" class="p-0"
                  ><img
                    src="@/assets/images/doorder/order-customer-active.png"
                    class="title-img title-img-active"
                  />
                  <img
                    src="@/assets/images/doorder/order-customer-done.png"
                    class="title-img title-img-done"
                  />
                </b-col>
                <b-col lg="10"
                  ><p class="step-order step-order-title">Customer</p>
                  <p class="step-order step-order-subtitle">
                    Customer Info
                  </p></b-col
                >
              </b-row>
            </template>
          </b-tab>
          <b-tab title-item-class="col-1 text-lg-left text-center" disabled>
            <template slot="title">
              <img
                src="@/assets/images/doorder/arrow-next.png"
                class="step-arrow"
                width="20"
              /> </template></b-tab
          ><b-tab title-item-class="col-lg-2 col-3 text-lg-left text-center">
            <template slot="title">
              <b-row>
                <b-col lg="2" class="p-0"
                  ><img
                    src="@/assets/images/doorder/order-package.png"
                    class="title-img title-img-default" /><img
                    src="@/assets/images/doorder/order-package-active.png"
                    class="title-img title-img-active" /><img
                    src="@/assets/images/doorder/order-package-done.png"
                    class="title-img title-img-done"
                /></b-col>
                <b-col lg="10"
                  ><p class="step-order step-order-title">Package</p>
                  <p class="step-order step-order-subtitle">
                    Package Details
                  </p></b-col
                >
              </b-row>
            </template>
          </b-tab>
          <b-tab
            title-item-class="col-1 text-lg-left text-center"
            disabled
            v-if="user_title == 'admin'"
          >
            <template slot="title">
              <img
                src="@/assets/images/doorder/arrow-next.png"
                class="step-arrow"
                width="20"
              /> </template></b-tab
          ><b-tab
            title-item-class="col-lg-2 col-3 text-lg-left text-center"
            lazy
            v-if="user_title == 'admin'"
          >
            <template slot="title">
              <b-row>
                <b-col lg="2" class="p-0"
                  ><img
                    src="@/assets/images/doorder/order-driver.png"
                    class="title-img title-img-default" /><img
                    src="@/assets/images/doorder/order-driver-active.png"
                    class="title-img title-img-active" /><img
                    src="@/assets/images/doorder/order-driver-done.png"
                    class="title-img title-img-done"
                /></b-col>
                <b-col lg="10"
                  ><p class="step-order step-order-title">Deliverers</p>
                  <p class="step-order step-order-subtitle">
                    Select Your Deliverer
                  </p></b-col
                >
              </b-row>
            </template>
          </b-tab>
          <b-tab
            title-item-class="col-1 text-lg-left text-center"
            disabled
            v-if="user_title == 'admin'"
          >
            <template slot="title">
              <img
                src="@/assets/images/doorder/arrow-next.png"
                class="step-arrow"
                width="20"
              /> </template></b-tab
          ><b-tab
            title-item-class="col-lg-2 col-3 text-lg-left text-center"
            v-if="user_title == 'admin'"
          >
            <template slot="title">
              <b-row>
                <b-col lg="2" class="p-0"
                  ><img
                    src="@/assets/images/doorder/order-delivery.png"
                    class="title-img title-img-default" /><img
                    src="@/assets/images/doorder/order-delivery-active.png"
                    class="title-img title-img-active"
                /></b-col>
                <b-col lg="10"
                  ><p class="step-order step-order-title">Delivery Details</p>
                  <p class="step-order step-order-subtitle">
                    Review Delivery Status
                  </p></b-col
                >
              </b-row>
            </template>
          </b-tab>
        </b-tabs>

        <b-row>
          <b-col md="6">
            <b-tabs id="myTabs" v-model="tabIndex" nav-wrapper-class="d-none">
              <b-tab>
                <CustomerDetails
                  type="view"
                  :order_number="order_number"
                  :status="status"
                  :status_str="status_str"
                  :first_name.sync="first_name"
                  :last_name.sync="last_name"
                  :customer_name="name"
                  :email.sync="email"
                  :contact_number.sync="contact_number"
                  :dropoff_address.sync="dropoff_address"
                  :dropoff_latitude.sync="dropoff_latitude"
                  :dropoff_longitude.sync="dropoff_longitude"
                  :dropoff_eircode.sync="dropoff_eircode"
              /></b-tab>
              <b-tab></b-tab>
              <b-tab>
                <PackageDetails
                  type="view"
                  :order_number="order_number"
                  :status="status"
                  :status_str="status_str"
                  :pickup_address.sync="pickup_address"
                  :fulfilment_date.sync="fulfilment_date"
                  :package_weight.sync="package_weight"
                  :package_size.sync="package_size"
                  :number_packages.sync="number_packages"
                  :deliver_by.sync="deliver_by"
                  :other_details.sync="other_details"
                  :is_fragile.sync="is_fragile"
                  :qr_scan_status="qr_scan_status"
                  :available_qr_codes="available_qr_codes"
              /></b-tab>
              <b-tab v-if="user_title == 'admin'"></b-tab>
              <b-tab lazy v-if="user_title == 'admin'">
                <DriverDetailsAndAssign
                  v-if="!is_archived"
                  type="view"
                  :order_id="order_id"
                  :order_number="order_number"
                  :status="status"
                  :status_str="status_str"
                  :dropoff_address="dropoff_address"
                  :circle_map_radius.sync="circle_map_radius"
                  :drivers_list.sync="drivers_list"
                />
                <DriverDetailsHistory
                  v-else
                  type="view"
                  :order_id="order_id"
                  :order_number="order_number"
                  :status="status"
                  :status_str="status_str"
                  :driver_name="driver_name"
                  :delivery_status="delivery_status"
                  :delivery_skip_reason="delivery_skip_reason"
                />
              </b-tab>
              <b-tab v-if="user_title == 'admin'"></b-tab>
              <b-tab lazy v-if="user_title == 'admin'"
                ><DeliveryDetails
                  type="view"
                  :order_id="order_id"
                  :order_number="order_number"
                  :status="status"
                  :status_str="status_str"
                  :assigned_driver="assigned_driver"
                  :cancel_reason="cancel_reason"
                  :comment.sync="comment"
              /></b-tab> </b-tabs
          ></b-col>
          <b-col md="6">
            <GmapMap
              :center="map_center"
              :zoom="11"
              map-type-id="terrain"
              class="order-map-container-doorder"
              ref="gmap"
            >
              <GmapCircle
                v-if="drawCircle"
                :center="pickup_marker.position"
                :radius="circle_map_radius * 1000"
                :visible="true"
                :options="{
                  strokeColor: '#f5da68',
                  strokeOpacity: 0.8,
                  strokeWeight: 1,
                  fillColor: '#f5da68',
                  fillOpacity: 0.4,
                }"
              ></GmapCircle>
              <GmapMarker
                :position="pickup_marker.position"
                :clickable="false"
                :draggable="false"
                :icon="marker_img_pickup"
              />
              <GmapMarker
                :position="dropoff_marker.position"
                :clickable="true"
                :draggable="false"
                :icon="marker_img_dropoff"
              />
              <GmapMarker
                :key="index"
                v-for="(m, index) in drivers_markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                :icon="marker_img_driver"
                @click="openInfoWindowTemplate(index)"
              />
              <gmap-info-window
                :options="{
                  maxWidth: 300,
                  pixelOffset: { width: 0, height: -25 },
                }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @closeclick="infoWindow.open = false"
              >
                <div v-html="infoWindow.template"></div>
              </gmap-info-window>
            </GmapMap>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-5">
          <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
            <b-button
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder mb-1 w-100 backbutton disabled"
              @click="tabIndex--"
              >Back</b-button
            >
          </b-col>
          <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
            <b-button
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder mb-1 w-100 nextbutton"
              @click="tabIndex++"
              >Next</b-button
            >
          </b-col>
          <b-col
            xl="2"
            lg="3"
            sm="4"
            class="px-md-1 text-center"
            v-if="user_title == 'admin' && !is_archived"
          >
            <b-button
              type="button"
              variant="doorder-danger-outline"
              class="btn-bumblebee btn-doorder w-100 mb-1"
              v-b-modal.delete-order-modal-doorder
              >Delete</b-button
            >
          </b-col>
          <b-col
            xl="2"
            lg="3"
            sm="4"
            class="px-md-1 text-center"
            v-else-if="
              user_title != 'admin' && status != 'delivered' && !is_archived
            "
          >
            <b-button
              type="button"
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder w-100 mb-1"
              @click="clickPrintLabel"
              >Print label</b-button
            >
          </b-col>
        </b-row>
        <!-- <div class="text-muted">Current Tab: {{ tabIndex }}</div> -->
      </b-card-body>
    </b-card>

    <!-- delete modal -->
    <DeleteOrderModal :order_id="order_id" />

    <!--print label-->
    <div id="printLabelDataDiv" class="d-none w-100">
      <div class="">
        <b-row class="header-row p-0 m-0">
          <b-col class="text-center py-3">
            <img
              src="@/assets/images/doorder/doorder-logo-inline.png"
              width="250px"
              height="80px"
            />
          </b-col>
        </b-row>
        <b-row class="mx-auto">
          <b-col>
            <b-form-group
              class="form-group-doorder"
              label="Name"
              label-for="name"
              label-class="form-label-print-doorder"
            >
              <span class="form-span-print-doorder">
                {{ name }}
              </span>
            </b-form-group></b-col
          >
        </b-row>
        <b-row class="mx-auto">
          <b-col>
            <b-form-group
              class="form-group-doorder"
              label="Eircode"
              label-for="eircode"
              label-class="form-label-print-doorder"
            >
              <span class="form-span-print-doorder">
                {{ dropoff_eircode }}
              </span>
            </b-form-group></b-col
          >
        </b-row>
        <b-row class="mx-auto">
          <b-col>
            <b-form-group
              class="form-group-doorder"
              label="Address"
              label-for="address"
              label-class="form-label-print-doorder"
            >
              <span class="form-span-print-doorder">
                {{ dropoff_address }}
              </span>
            </b-form-group></b-col
          >
        </b-row>
        <b-row class="mx-auto">
          <b-col>
            <b-form-group
              class="form-group-doorder"
              label="Phone number"
              label-for="contact_number"
              label-class="form-label-print-doorder"
            >
              <span class="form-span-print-doorder">
                {{ contact_number }}
              </span>
            </b-form-group></b-col
          >
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import { getOrderStatusClassAndStr } from "@/utils/helper-functions-doorder.js";
import DatePicker from "vue2-datepicker";

import { gmapApi } from "vue2-google-maps";

import CustomerDetails from "./order_details_components/CustomerDetails.vue";
import PackageDetails from "./order_details_components/PackageDetails.vue";
import DeliveryDetails from "./order_details_components/DeliveryDetails.vue";
import DriverDetailsAndAssign from "./order_details_components/DriverDetailsAndAssign.vue";
import DriverDetailsHistory from "./order_details_components/DriverDetailsHistory.vue";

import DeleteOrderModal from "./DeleteOrderModel.vue";
import print from "print-js";

var table;
export default {
  name: "DoorderViewOrder",
  components: {
    DatePicker,
    CustomerDetails,
    PackageDetails,
    DeliveryDetails,
    DriverDetailsAndAssign,
    DriverDetailsHistory,
    DeleteOrderModal,
  },
  data() {
    return {
      client_name: "DOORDER",
      google: gmapApi,

      user_title: null,
      order_id: null,
      order: null,
      tabIndex: 0,

      is_archived: 0,

      order_number: null,
      status: null,
      status_str: null,
      //customer details
      first_name: null,
      last_name: null,
      name: null,
      email: null,
      contact_number: null,
      dropoff_address: null,
      dropoff_eircode: null,
      dropoff_latitude: "",
      dropoff_longitude: "",
      // package details
      pickup_address: null,
      pickup_latitude: "",
      pickup_longitude: "",
      fulfilment_date: "",
      package_weight: "",
      package_size: "",
      number_packages: "",
      deliver_by: "",
      other_details: "",
      is_fragile: 0,
      qr_scan_status: "No QR scan required",
      available_qr_codes: [
        "https://staging.doorder.eu/uploads/pdfs/Zg7xIVhoZxkk58E1X1duHwTERN2zN5ur.pdf",
        "https://staging.doorder.eu/uploads/pdfs/A3NwBSxqIycKjdda4PsT45VVIfoK4tut.pdf",
      ],
      //driver
      driver_name: null,
      delivery_status: null,
      delivery_skip_reason: null,
      //delivery status
      assigned_driver: null,
      cancel_reason: null,
      comment: null,

      overlay_show: false,
      map_center: { lat: 53.364379779866695, lng: -6.271807338634555 },
      drivers_markers: [
        {
          position: { lat: 53.408077, lng: -6.6881827 },
          user: { name: "sara reda" },
        },
        {
          position: { lat: 53.639495, lng: -6.60881827 },
          user: { name: "rania reda" },
        },
        {
          position: { lat: 53.4208077, lng: -6.65881827 },
          user: { name: "mohamed fayez" },
        },
      ],
      pickup_marker: {},
      dropoff_marker: {},
      marker_img_driver: {
        url: require("@/assets/images/doorder/map-pin-driver.png"),
        scaledSize: { width: 40, height: 40 },
      },

      marker_img_pickup: {
        url: require("@/assets/images/doorder/map-pin-pickup.png"),
        scaledSize: { width: 40, height: 40 },
      },
      marker_img_dropoff: {
        url: require("@/assets/images/doorder/map-pin-customer.png"),
        scaledSize: { width: 40, height: 40 },
      },
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: "",
      },
      circle_map_radius: 10,
      drawCircle: false,

      drivers_list: [],
    };
  },
  mounted() {
    console.log(this.$route.params.id);
    this.order_id = this.$route.params.id;
    let user = JSON.parse(window.localStorage.getItem("user"));
    // console.log(user)
    this.user_title = user.title;
    // console.log(this.user_title, user.title)
    this.getOrderDetails();
  },
  watch: {
    tabIndex(newval, oldval) {
      console.log("tab index", newval);
      $(".form-steps-container-doorder .nav-tabs .nav-item .nav-link").addClass(
        "previous"
      );

      let tabs = $(
        ".form-steps-container-doorder .nav-tabs .nav-item .nav-link"
      );
      let temp = this;
      setTimeout(function () {
        $(
          ".form-steps-container-doorder .nav-tabs .nav-item .nav-link"
        ).removeClass("previous");
        $.each(
          $(".form-steps-container-doorder .nav-tabs .nav-item .nav-link"),
          function (i, val) {
            if (i < newval) {
              // console.log(i, val);
              // console.log($(this));
              $(val).addClass("previous");
            }
          }
        );

        if (newval == 0) {
          $(".backbutton").addClass("disabled");
        } else {
          $(".backbutton").removeClass("disabled");
        }
        if (temp.user_title == "admin") {
          if (newval == 6) {
            $(".nextbutton").addClass("disabled");
          } else {
            $(".nextbutton").removeClass("disabled");
          }
        } else {
          if (newval == 2) {
            $(".nextbutton").addClass("disabled");
          } else {
            $(".nextbutton").removeClass("disabled");
          }
        }
      }, 15);

      // for(let i=0; i<newval; i++){
      //   $(tabs[i]).addClass("previous")
      // }
    },
  },

  methods: {
    getOrderStatusClassAndStr,
    openInfoWindowTemplate(index) {
      const location = this.drivers_markers[index];
      // console.log(location);
      this.infoWindow.position = location.position;
      this.infoWindow.template = `<p class="mapNameP">${location.user.name}</p>`;
      this.infoWindow.open = true;
    },
    getOrderDetails() {
      axios
        .get("/jobs/jobs/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          let order = response.data;

          this.order_number = order.order_id;
          this.status = order.status;
          if (order.status == "assigned") {
            order.status = "matched";
            this.status = "matched";
          }
          this.status_str = this.getOrderStatusClassAndStr(order.status);
          this.is_archived = order.is_archived;

          this.name = order.contact.name;
          this.email = order.contact.email;
          this.contact_number = order.contact.phone;
          this.dropoff_address = order.location;
          this.dropoff_eircode = order.post_code;

          this.pickup_address = order.pickup;
          this.pickup_latitude = order.pickup_lat;
          this.pickup_longitude = order.pickup_lang;
          this.fulfilment_date = order.fulfilment_date;
          this.package_weight = order.weight;
          this.package_size = order.dimensions;
          this.number_packages = order.number_of_packages;
          this.deliver_by = order.deliver_by;
          this.other_details = order.description;
          this.is_fragile = order.fragile;

          this.assigned_driver =
            order.operator != null ? order.operator.name : "N/A";
          this.cancel_reason = order.canceled_reason;
          this.comment = order.note;

          this.driver_name =
            order.operator != null ? order.operator.name : "N/A";
          this.delivery_status =
            order.operator_confirmation_status == "confirmed"
              ? "The customer has confirmed the delivery"
              : "The deliverer has skipped the confirmation";
          this.delivery_skip_reason =
            order.canceled_reason != null ? order.canceled_reason : "N/A";

          this.pickup_marker = {
            position: {
              lat: parseFloat(order.pickup_lat),
              lng: parseFloat(order.pickup_lang),
            },
          };
          this.map_center = {
            lat: parseFloat(order.pickup_lat),
            lng: parseFloat(order.pickup_lang),
          };
          this.dropoff_marker = {
            position: {
              lat: parseFloat(order.location_lat),
              lng: parseFloat(order.location_lang),
            },
          };
          this.drawCircle = true;

          if (this.user_title == "admin") {
            this.getDriversList();
          }
        });
    },

    getDriversList() {
      axios
        .get("/operator/operators", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response.data.data);
          this.drivers_list = response.data.data;

          this.drivers_list.push({
            id: 20,
            name: "sara reda",
            transport: "Car",
            latest_coordinates: '{"lat":"53.408077","lng":"-6.6881827"}',
          });
          this.drivers_list.push({
            id: 21,
            name: "rania reda",
            transport: "Car",
            latest_coordinates: '{"lat":"53.639495","lng":"-6.60881827"}',
          });
          this.drivers_list.push({
            id: 22,
            name: "mohamed fayez",
            transport: "Car",
            latest_coordinates: '{"lat":"53.4208077","lng":"-6.65881827"}',
          });

          for (let i = 0; i < this.drivers_list.length; i++) {
            console.log("======>");
            if (this.drivers_list[i].latest_coordinates != null) {
              let loc = this.drivers_list[i].latest_coordinates;
              console.log(loc);
              loc = JSON.parse(loc);
              console.log(loc);
              console.log(this.pickup_latitude, this.pickup_longitude);
              let latest_lat = loc.lat,
                latest_lng = loc.lng,
                pickup_lat = this.pickup_latitude,
                pickup_lng = this.pickup_longitude;

              let distance =
                google.maps.geometry.spherical.computeDistanceBetween(
                  new google.maps.LatLng(pickup_lat, pickup_lng),
                  new google.maps.LatLng(latest_lat, latest_lng)
                );
              console.log(this.drivers_list[i].name, distance, distance / 1000);
              this.drivers_list[i].driverkmaway = parseFloat(
                distance / 1000
              ).toFixed(2);
            } else {
              this.drivers_list[i].driverkmaway = "N/A";
            }
          }

          console.log(this.drivers_list);
        });
    },
    clickPrintLabel() {
      console.log("in click print label ");
      printJS({
        printable: "printLabelDataDiv",
        type: "html",
        maxWidth:"100%",
        targetStyles:'*',
        style:
          "#printLabelDataDiv {display:block !important; width: 100vw !important; padding:0 !important; margin:-10px !important}  "+
          "#printLabelDataDiv .header-row{width:100% !important; -webkit-print-color-adjust: exact; color-adjust: exact;} "+
          "#printLabelDataDiv .row:first-child .col  {text-align: center;} "+
          "#printLabelDataDiv .row span{font-weight: 600} ",
        // css: [
        //   require("@/assets/css/material-dashboard.min.css"),
        //   require("@/components/doorder/css/doorder-styles.css"),
        // ],
      });
    },
  },
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/doorder/orders/ViewOrder.vue